import React, { Component } from "react";
import WhenAuthorized from "../WhenAuthorized";
import * as roles from "../../utils/roles";
import { Grid, GridItem, Breadcrumbs, BreadcrumbsItem, Button } from "@sainsburys-tech/fable";
import { Link } from "react-router-dom";
import { forkJoin } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { componentFromStream } from "recompose";
import withLoadingAndErrorHandling from "../../utils/reactive/wrapPageApiCall.js";
import PageTitle from "../PageTitle";
import OverridesGroupedList from "../OverridesGroupedList";
import OverrideDiscardModal from "../OverrideDiscardModal";
import { Redirect } from "react-router-dom";
import { OverrideToastConsumer } from "../WithOverrideToastManager";
import { Delete } from '@sainsburys-tech/icons'
import * as overrideStages from "../../model/lighting-overrides/overrideStageKeys";
class OverridesGroupedListPage extends Component {
  state = {
    discardModalOpen: false,
    overrideToDiscard: null,
    redirectToOverridesPage: false
  };

  handleDiscardModalClose = () => {
    this.closeDiscardDialog();
  };

  handleDiscardSuccess = () => {
    const override = this.props.override;
    if (override) {
      this.props.toastManager.monitorOverrideStage(
        override[0].overrideId,
        override[0].overrideName
      );
    }
    this.redirectToOverridesPage();
  };

  closeDiscardDialog = () => {
    this.setState({ discardModalOpen: false, overrideToDiscard: null });
  };

  openDiscardDialog = override => {
    this.setState({
      discardModalOpen: true,
      overrideToDiscard: this.props.override[0].overrideId
    });
  };

  redirectToOverridesPage = () => {
    this.setState({ redirectToOverridesPage: true });
  };

  render() {
    if (this.state.redirectToOverridesPage) {
      return <Redirect to={`/lighting/overrides`} push={true} />;
    }
    return (
      <PageTitle title={this.props.override[0].overrideName}>
        <React.Fragment>
          <Breadcrumbs shouldShowCurrentPage={true}>
            <BreadcrumbsItem href="/lighting/overrides">
              Lighting overrides
            </BreadcrumbsItem>
            <BreadcrumbsItem href={`/lighting/overrides/${this.props.override[0].overrideId}`}>
              {this.props.override[0].overrideName}
            </BreadcrumbsItem>
          </Breadcrumbs>

          <div>
            <Grid cols={4} gap="md" className="fable:pb-8">
              <GridItem colSpan={3}>
                <h3>{this.props.override[0].overrideName}</h3>
              </GridItem>
              <GridItem colSpan={1} className="fable:text-right">
                <WhenAuthorized roles={[roles.LIGHTING_OVERRIDES_WRITE]}>
                  {this.props.override.filter(
                    x => x.stage.stage.description === overrideStages.COMPLETED
                  ).length >= 1 ? (
                    <Button
                      variant="secondary"
                      onClick={() =>
                        this.openDiscardDialog(this.props.override)
                      }
                    >
                      <Delete fixed />
                      Discard overrides
                    </Button>
                  ) : (
                    ""
                  )}
                </WhenAuthorized>
              </GridItem>
            </Grid>
            <OverridesGroupedList data={this.props.override} />
            <OverrideDiscardModal
              open={this.state.discardModalOpen}
              overrideId={
                this.state.overrideToDiscard
                  ? this.state.overrideToDiscard
                  : null
              }
              onClose={this.handleDiscardModalClose}
              onDiscardSuccess={override => this.handleDiscardSuccess(override)}
            />
          </div>
        </React.Fragment>
      </PageTitle>
    );
  }
}

const mapOverride = override => {
  if (override != null) {
    return override.stores.map(store => {
      return {
        overrideId: override.overrideId,
        overrideName: override.name,
        store: store.name + " (" + store.storeId + ")",
        zones: "All",
        start: override.start,
        end: override.end,
        created: override.created,
        stage: override.overrideStages.find(x => x.storeId === store.storeId)
      };
    });
  }
};

export default componentFromStream(props$ => {
  return withLoadingAndErrorHandling(() =>
    props$.pipe(
      mergeMap(({ getOverride, overrideId }) =>
        forkJoin([getOverride(overrideId)])
      ),
      map(([override]) => (
        <OverrideToastConsumer>
          {toastManagerContext => (
            <OverridesGroupedListPage
              toastManager={toastManagerContext}
              override={mapOverride(override)}
            />
          )}
        </OverrideToastConsumer>
      ))
    )
  );
});
